export enum BonusType {
  Rate = 'rate',
  Fixed = 'fixed',
}
